"use client";

import { motion, useScroll, useSpring } from "framer-motion";
import type { RefObject } from "react";
import { useHeaderOffset } from "@/lib/use-header-offset";

/** Exportiert fuer table-of-contents.tsx, um seinen eigenen sticky-Offset danach auszurichten. */
export const READING_PROGRESS_BAR_HEIGHT_PX = 3;

/**
 * Lese-Fortschrittsbalken direkt unter dem Banner (Erik-Wunsch 2026-08-04): fuellt sich
 * beim Scrollen durch den Analyse-Text von links nach rechts und bleibt dabei sichtbar
 * ("mitlaeuft") - position: sticky direkt unterhalb des globalen Headers statt einmalig
 * statisch zu rendern.
 *
 * An articleRef gebunden (nicht die ganze Seite), damit 0%/100% exakt den Artikelanfang/
 * -ende markieren, nicht z.B. den Kommentarbereich danach. scaleX statt width: reiner
 * GPU-Transform ohne Layout-Reflow pro Scroll-Frame.
 */
export function ReadingProgressBar({ articleRef }: { articleRef: RefObject<HTMLElement | null> }) {
  const headerOffset = useHeaderOffset();
  const { scrollYProgress } = useScroll({ target: articleRef, offset: ["start start", "end end"] });
  const scaleX = useSpring(scrollYProgress, { stiffness: 220, damping: 32, restDelta: 0.001 });

  return (
    <div
      aria-hidden="true"
      className="sticky z-20 bg-muted print:hidden"
      style={{ top: headerOffset, height: READING_PROGRESS_BAR_HEIGHT_PX }}
    >
      <motion.div className="h-full origin-left bg-gold" style={{ scaleX }} />
    </div>
  );
}
